import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/font-awesome/css/font-awesome.min.css';
import './styles/mf.css';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import HeroImageComponent from './components/heroImageComponent/HeroImageComponent';
import BannerComponent from './components/bannerComponent/BannerComponent';
import OverviewComponent from './components/overviewComponent/OverviewComponent';
import RunSequenceComponent from './components/runSequenceComponent/RunSequenceComponent';
import ConsoleLogComponent from './components/consoleLogComponent/ConsoleLogComponent';
import CardinalCollectionComponent from './components/cardinalCollectionComponent/CardinalForm';
import StartoverComponent from './components/startoverComponent/StartoverComponent';
import GifComponent from './components/gifComponent/GifComponent';

function App() {
  const { displayStartOver } = useSelector((state) => state.runSeqReducer);
  useEffect(() => {
    const mfScriptTag = document.createElement('script');
    mfScriptTag.src = 'js/mf.js';
    mfScriptTag.async = true;
    document.getElementById('script').appendChild(mfScriptTag);
  });

  return (
    <div className="container-fluid conatiner-main">
      <HeroImageComponent />
      <div className="row mainContent">
        <div className="row">
          <div className="col-lg-12">
            <BannerComponent />
            <OverviewComponent content="" />
          </div>
        </div>
        <hr style={{ margin: '0' }} />
        <div className="row container_sequence_checkout">
          <div className="col-lg-5">
            <RunSequenceComponent />
          </div>
          <div className="col-lg-7">
            {displayStartOver && displayStartOver === true ? (
              <StartoverComponent />
            ) : (
              <GifComponent />
            )}
          </div>
        </div>
        <div className="row container_consolelog">
          <div className="col-lg-12">
            <ConsoleLogComponent />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <CardinalCollectionComponent />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
